// This will only work on localhost or live with SSL

const copyLinkTargets = document.querySelectorAll("[data-copy]");

copyLinkTargets.forEach((copyLinkTarget) => {
  copyLinkTarget.addEventListener("click", function ({ target }) {
    const copyLinkText = target.querySelector(".copyLinkText");
    const copyLinkValue = target.dataset.copy;

    // Copy to clipboard
    navigator.clipboard.writeText(copyLinkValue);

    // Assistive tech feedback
    copyLinkText.innerHTML = "Link copied";

    // Visual feedback
    target.classList.add("__active");

    // Reset after 2 seconds
    setTimeout(function () {
      target.classList.remove("__active");
      copyLinkText.innerHTML = "Copy link";
    }, 2000);
  });
});

